import {FormHelperText, MenuItem, Select} from '@mui/material'
import React, {FC} from 'react'


interface Props {
    value: any,
    name: string

    handleChange(val: any): void,

    handleSubmit?(): void,

    icon?: any,
    items: Array<{
        value: string | number | undefined,
        name: string
    }> | undefined,
    width?: string,
    height?: string,
    bgc?: string,
    bRadius?: string,
    helperText?: any,
    isDisabled?: boolean
}


const CustomSelect: FC<Props> = ({
                                     value,
                                     handleChange,
                                     icon,
                                     items,
                                     name, width,
                                     height = "40px",
                                     bRadius = "5px",
                                     isDisabled,
                                     helperText,
                                     bgc = "#FFFFFF",
                                     handleSubmit
                                 }) => {

    const onChange = (e: any) => {
        handleChange(e)
        handleSubmit && handleSubmit()
    }
    return <>
        <Select
            value={value}
            onChange={onChange}
            name={name}
            IconComponent={icon && icon}
            disabled={isDisabled}
            sx={{
                height: height,
                background: bgc,
                borderRadius: bRadius,
                color: "primary.dark",
                width: width,
                fontSize: "16px"
            }}
        >
            {items && items.map((item) => {
                    return <MenuItem key={item.name}
                                     value={item.value}
                                     sx={{
                                         color: "primary.dark",
                                     }}

                    >{item.name}</MenuItem>
                }
            )}
        </Select>
        <FormHelperText sx={{color: "#FC4B4A"}}>
            {helperText}
        </FormHelperText>
    </>
}

export default CustomSelect